import Layout from "../../../../src/components/layout";
import React from 'react';
export default {
  Layout,
  React
};